// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_infos_grafico_orcamentos_sem_compromisso_mes_a_mes
 *
 * Returns array of monthly orcamento statistics (12 months).
 */
import type { GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesRow } from './GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesResponseDados = GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesRow[];

export type GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesResponse = ApiResponse<GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesResponseDados>;

registerResponseContract('GestaoClientes_CarregaInfosGraficoOrcamentosSemCompromissoMesAMesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      total_total: { type: 'number',  required: false },
      nome_data:   { type: 'string',  required: true },
      items: {
        type: 'array',
        required: false,
        items: {
          ID:                      { type: 'number',  required: true },
          acoes:                   { type: 'string',  required: true },
          agendar:                 { type: 'string',  required: true },
          status:                  { type: 'string',  required: true },
          status_label:            { type: 'string',  required: true },
          orcamento_data:          { type: 'string',  required: true },
          orcamento_franquia_id:   { type: 'string',  required: true },
          nome_cliente:            { type: 'string',  required: true },
          pode_agendar:            { type: 'string',  required: true },
          cliente_id:              { type: 'string',  required: true },
          cliente_ddi:             { type: 'string',  required: false },
          cliente_ddd:             { type: 'string',  required: false },
          cliente_telefone:        { type: 'string',  required: false },
          rua:                     { type: 'string',  required: false },
          bairro:                  { type: 'string',  required: false },
          orcamento_location_id:   { type: 'string',  required: false },
          orcamento_location_type: { type: 'string',  required: false },
          total:                   { type: 'string',  required: true },
          origem:                  { type: 'string',  required: false },
          franquia:                { type: 'string',  required: false },
          Localidade:              { type: 'string',  required: false },
        },
      },
      qtd:         { type: 'number',  required: false },
    },
  },
})
